import { render, staticRenderFns } from "./auditorias.vue?vue&type=template&id=3ecb059c"
import script from "./auditorias.vue?vue&type=script&lang=js"
export * from "./auditorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports